class CustomSelectDropdown extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.cs-select-wrapper');
    this.trigger = this.querySelector('.cs-trigger');
    this.options = this.querySelectorAll('.cs-option');
    this.label = this.querySelector('.cs-current-label');
    
    // Bind methods
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
  }

  connectedCallback() {
    // Find the original select in the previous sibling element (the hidden .select div)
    // We traverse up to the parent and find the select
    const parent = this.closest('.facet-filters__field');
    if (parent) {
      this.originalSelect = parent.querySelector('select');
    }

    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });
    }

    this.options.forEach(option => {
      option.addEventListener('click', this.onOptionClick);
    });

    document.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.toggle);
    }
    document.removeEventListener('click', this.close);
  }

  toggle() {
    this.wrapper.classList.toggle('open');
  }

  close(e) {
    if (this.wrapper && !this.wrapper.contains(e.target)) {
      this.wrapper.classList.remove('open');
    }
  }

  onOptionClick(e) {
    e.stopPropagation();
    const value = e.currentTarget.dataset.value;
    const text = e.currentTarget.textContent.trim();

    // Update UI
    if (this.label) {
      this.label.textContent = text;
    }
    this.wrapper.classList.remove('open');

    // Update Active State
    this.options.forEach(opt => opt.classList.remove('selected'));
    e.currentTarget.classList.add('selected');

    // Update Original Select
    if (this.originalSelect) {
      this.originalSelect.value = value;
      // Dispatch input event to trigger Shopify's sorting logic
      this.originalSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

if (!customElements.get('custom-select-dropdown')) {
  customElements.define('custom-select-dropdown', CustomSelectDropdown);
}
